// @ts-nocheck
import * as React from "react";

const BookmarkLine: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path fill="currentColor" d="M6 19.5V4h12v15.5l-6-2.583L6 19.5Zm1-1.55 5-2.15 5 2.15V5H7v12.95Z" />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(BookmarkLine);
